export enum DrawerNames {
  AddEvidence = 'add-evidence',
  AddUser = 'add-user',
  ShareWithUsers = 'share-with-users',
  ShareWithGuests = 'share-with-guests',
  AddToCase = 'add-to-case',
  UpdateEvidence = 'update-evidence',
  NewCase = 'new-case',
  UpdateCaseDetails = 'update-case-details',
  AddCase = 'add-case',
  LinkCase = 'link-case',
  UpdateUserDetails = 'update-user-details',
  UpdateAgencyDetails = 'update-agency-details',
  NewDevice = 'new-device',
  AssignDevice = 'assign-device',
  NewCategory = 'new-category',
  UpdateCategory = 'update-category',
  InviteGuestsToCase = 'invite-guests-to-case',
  UpdatePermission = 'update-permission',
  CreateUser = 'create-user',
  SetLocation = 'set-location',
  UpdateEvidenceLossResilience = 'update-evidence-loss-resilience',
  AssignUserToRespondent = 'assign-user-to-respondent',
  HandleEvent = 'handle-event',
}
